import PendoMultiselect from '../multiselect/pendo-multiselect.vue.js';
import PendoIconOption from '../multiselect/option-types/pendo-icon-option.vue.js';
import PendoIcon from '../icon/pendo-icon.vue.js';
import PendoButton from '../button/pendo-button.vue.js';
import timeranges from './time-range.js';

var script = {
  name: 'PendoTimePicker',
  components: {
    PendoMultiselect,
    PendoIconOption,
    PendoIcon,
    PendoButton
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Select Time'
    },
    invalid: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    options() {
      return timeranges.map(time => ({
        label: time,
        value: time,
        icon: {
          type: 'clock'
        }
      }));
    },
    model: {
      get() {
        return this.options.find(option => option.value === this.value);
      },
      set(_ref) {
        let {
          value
        } = _ref;
        this.$emit('change', value);
        this.$emit('input', value);
      }
    }
  },
  methods: {
    clearModel() {
      this.model = {
        value: null
      };
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-time-picker.vue2.js.map
